import React, { Component } from "react";
import { Redirect } from "react-router-dom";
//Service import
import service from '../services'
import moment from 'moment'
let sub;
export default class TablistGenre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activetab: props.active || 0,
      data: [
        {
          label: "FILMS",
          Content: "This is content for Tab 1",
        },
        {
          label: "EVENTS",
          Content: "This is content for Tab 2",
        },
      ],
    };
    this.apiserve = new service();
  }

  TabClick = (index) => {
    this.setState({
      activetab: index,
    }, () => {
      this.updatedAt()
    });
  };
  componentWillUnmount = () => {
    sub.unsubscribe();
}

  componentDidMount() {
    this.updatedAt();
    sub = this.apiserve.getevent().subscribe((response) => {
      switch(response.event){
        case "film|getLastUpdated":
          this.setState({
            getLastUpdated:response.data
          })
          break;

          default:break;
      }
    })
  }

updatedAt = () => {
  var data={}
  if(this.state.activetab === 0){
      data.type=12
  }
  if(this.state.activetab === 1){
      data.type=13
  }
  this.apiserve.sendevent("film|getLastUpdated", data);
}
  render() {
    const {getLastUpdated} = this.state
        var updateAt = new Date (getLastUpdated && getLastUpdated.updatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy
    return (
      <>
        <ul className="fpg_admin_tab disp_flex">
          {this.state.data &&
            this.state.data.map((list, index) => {
              return (
                <li
                  key={index}
                  className={this.state.activetab === index ? "active" : ""}
                  onClick={() => this.TabClick(index)}
                >
                  <p><div>{list.label}</div></p>
                </li>
              );
            })}
        </ul>
        <div class="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
          <p></p>
          {this.state.getLastUpdated && this.state.getLastUpdated.updatedAt === undefined ? '' :
            <p class="update_date">Last Update: {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
          }
        </div>
        {this.state.activetab === 0 ? <Redirect to="/filmgenre" /> : ""}
        {this.state.activetab === 1 ? (
          <Redirect to="/eventsgenre" />
        ) : (
          ""
        )}
      </>
    );
  }
}
